import { Action, createReducer, on } from '@ngrx/store';
import * as DeviceThActions from './device-th.actions';
import { DevicesThGroupsData, DevicesThGroupsV2Data, ThDeviceStatus } from 'src/app/model/api/data-rest';
import { LogThExport } from 'src/app/conf/thermo';
import { Thermo, ThermoLog } from 'src/app/model/thermo';
import { User } from 'src/app/model/user';


export interface State {
    thGroupsList: DevicesThGroupsData;
    thGroupsListV2: DevicesThGroupsV2Data;
    thDeviceStatus: ThDeviceStatus;
    deviceThermo: Thermo;

    thLogLoading: boolean;
    thLogData: ThermoLog;
    loadingThLogExp: boolean;
    loadedThLogExp: boolean;
    logThExport: LogThExport;
    loadingThGroups: boolean;
    savingThGroups: boolean;

    currentThGroupFinalUsers: User[];
    thGroupShareInvitationRevoking: boolean;
    thGroupShareInvitationRevoked: boolean;
    thGroupSharingRemoving: boolean;
    thGroupSharingRemoved: boolean;
}

const initialState: State = {
    thGroupsList: undefined,
    thGroupsListV2: undefined,
    thDeviceStatus: undefined,
    deviceThermo: new Thermo,

    thLogLoading: false,
    thLogData: null,
    loadingThLogExp: false,
    loadedThLogExp: false,
    logThExport: new LogThExport,
    loadingThGroups: false,
    savingThGroups: false,

    currentThGroupFinalUsers: [],
    thGroupShareInvitationRevoking: false,
    thGroupShareInvitationRevoked: false,
    thGroupSharingRemoving: false,
    thGroupSharingRemoved: false,
};

const deviceThReducer = createReducer(
    initialState,

    on(DeviceThActions.getDevicesThListSuccess, (state, payload) => ({
        ...state,
        thGroupsList: payload.thGroupsList
    })),
    on(DeviceThActions.getDevicesThListV2, (state) => ({
        ...state,
        loadingThGroups: true,
    })),
    on(DeviceThActions.getDevicesThListV2Success, (state, payload) => ({
        ...state,
        thGroupsListV2: payload.thGroupsListV2,
        loadingThGroups: false,
    })),
    on(DeviceThActions.getDevicesThListV2Failed, (state) => ({
        ...state,
        loadingThGroups: false,
    })),
    on(DeviceThActions.getDeviceThStatusSuccess, (state, payload) => ({
        ...state,
        thDeviceStatus: payload.thDeviceStatus
    })),
    on(DeviceThActions.getLogThExportReset, (state) => ({
        ...state,
        loadingThLogExp: false,
        loadedThLogExp: false,
        logThExport: new LogThExport(),
    })),
    on(DeviceThActions.getLogThExport, (state) => ({
        ...state,
        loadingThLogExp: true,
        loadedThLogExp: false,
        logThExport: new LogThExport(),
    })),
    on(DeviceThActions.getLogThExportSuccess, (state, payload) => ({
        ...state,
        loadingThLogExp: false,
        loadedThLogExp: true,
        logThExport: payload.logThExport,
    })),
    on(DeviceThActions.getLogThExportFailed, (state) => ({
        ...state,
        loadingThLogExp: false,
        loadedThLogExp: false,
        logThExport: new LogThExport(),
    })),
    on(DeviceThActions.getThLog, (state) => ({
        ...state,
        thLogLoading: true,
        thLogData: null
    })),
    on(DeviceThActions.getThLogSuccess, (state, payload) => ({
        ...state,
        thLogLoading: false,
        thLogData: payload.thermoLog
    })),
    on(DeviceThActions.getThLogFailed, (state) => ({
        ...state,
        thLogLoading: false,
        thLogData: null
    })),
    on(DeviceThActions.getThermoDeviceV2Success, (state, payload) => ({
        ...state,
        deviceThermo: payload.deviceThermo,
    })),
    on(DeviceThActions.setGroupSiteAssociation, (state) => ({
        ...state,
        savingThGroups: true,
    })),
    on(DeviceThActions.setGroupSiteAssociationSuccess, (state) => ({
        ...state,
        savingThGroups: false,
    })),
    on(DeviceThActions.setGroupSiteAssociationFailed, (state) => ({
        ...state,
        savingThGroups: false,
    })),
    on(DeviceThActions.getFinalUsersThGroupSuccess, (state, payload) => ({
        ...state,
        currentThGroupFinalUsers: payload.finalUsers
    })),
    // on(DeviceThActions.removeShareThGroupSuccess, (state, payload) => ({
    //     ...state, currentThGroupFinalUsers: state.currentThGroupFinalUsers.filter(fu => fu.Id !== payload.userId)
    // })),
    // on(DeviceThActions.revokeShareInvitationThGroupSuccess, (state, payload) => ({
    //     ...state, currentThGroupFinalUsers: state.currentThGroupFinalUsers.filter(fu => fu.Email !== payload.email)
    // })),
    // on(DeviceThActions.revokeShareInvitationThGroupReset, (state) => ({ ...state, thGroupShareInvitationRevoking: false })),
    on(DeviceThActions.revokeShareInvitationThGroup, (state) => ({ ...state, thGroupShareInvitationRevoking: true, thGroupShareInvitationRevoked: false })),
    on(DeviceThActions.revokeShareInvitationThGroupSuccess, (state) => ({ ...state, thGroupShareInvitationRevoking: false, thGroupShareInvitationRevoked: true })),
    on(DeviceThActions.revokeShareInvitationThGroupFailed, (state) => ({ ...state, thGroupShareInvitationRevoking: false, thGroupShareInvitationRevoked: true })),
    on(DeviceThActions.removeShareThGroup, (state) => ({ ...state, thGroupSharingRemoving: true, thGroupSharingRemoved: false })),
    on(DeviceThActions.removeShareThGroupSuccess, (state) => ({ ...state, thGroupSharingRemoving: false, thGroupSharingRemoved: true })),
    on(DeviceThActions.removeShareThGroupFailed, (state) => ({ ...state, thGroupSharingRemoving: false, thGroupSharingRemoved: true })),
);

export const reducer = (state: State | undefined, action: Action): State => deviceThReducer(state, action);

